import { useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';

import { api } from '../../../lib/api.js';
import { WorkspaceDetail } from '@raven/shared-types';

export function ServicesPage() {
  const { id } = useParams({ strict: false }) as { id: string };
  const { data, isPending, error } = useQuery({
    queryKey: ['workspace', id],
    queryFn: () => api.get(`/api/workspaces/${encodeURIComponent(id)}`, WorkspaceDetail),
  });
  if (isPending) return <div className="card text-sm text-slate-500">Loading…</div>;
  if (error) return <div className="card text-sm text-red-600">{String(error)}</div>;
  const ws = data!;

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      {ws.modulesOnboarded.map((m) => (
        <div key={m} className="card">
          <header className="flex items-center justify-between">
            <h3 className="text-base font-semibold">{m}</h3>
            <span className="badge bg-emerald-50 text-emerald-700">enabled</span>
          </header>
          <dl className="mt-4 grid grid-cols-3 gap-x-4 gap-y-2 text-sm">
            <dt className="text-slate-500">Backend</dt>
            <dd className="col-span-2 break-words">
              {(ws.backend as Record<string, { domain?: string; endpoint?: string }> | null)?.[m]?.domain ??
                '—'}
            </dd>
            <dt className="text-slate-500">TTL</dt>
            <dd className="col-span-2">
              {typeof ws.ttl === 'object' && ws.ttl !== null
                ? String((ws.ttl as Record<string, unknown>)[m] ?? '—')
                : String(ws.ttl ?? '—')}
            </dd>
            {m === 'MARLIN' && (
              <>
                <dt className="text-slate-500">CloudFront</dt>
                <dd className="col-span-2 truncate">
                  {ws.CloudFrontDetails ? 'configured' : 'not configured'}
                </dd>
              </>
            )}
            {m === 'SPIDER' && ws.mcp_conf && (
              <>
                <dt className="text-slate-500">MCP</dt>
                <dd className="col-span-2">
                  {(ws.mcp_conf as Record<string, unknown>).displayName as string | undefined}
                </dd>
              </>
            )}
          </dl>
        </div>
      ))}
    </div>
  );
}
